(ns app.front.view.workspace.top-bar
  (:require [app.domain.business.model :as business-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.party.model :as party-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.view.workspace.subs :as ws-subs]
            [core.db.entity-api :as entity-api]
            [core.front.event :refer [<sub]]))

(defn breadcrumb-fallback [{:keys [match]}]
  (when-let [view-name (-> match :data :name)]
    (let [tr (<sub [::ws-subs/tr-quiet])]
      [view-name (-> match :parameters :path) (tr [view-name])])))

(defn project-or-business [{:keys [tr match]}]
  (let [{:keys [workspace-id]} (-> match :parameters :path)
        lang                   (<sub [:language])
        workspace              (<sub [::entities/entity {:workspace/id workspace-id}])
        project                (when (entity-api/entity? (:entity/parent workspace))
                                 (:entity/parent workspace))
        businesses             (when-not project
                                 ;; business is an alternative to project in breadcrumb
                                 (->> workspace
                                      workspace-model/workspace-application
                                      party-model/phase-applicant-businesses))
        project-id             (or (-> workspace :entity/parent :db/id)
                                   (:entity/parent workspace))]
    (cond
      ;; if there is a project, always only show that
      project-id
      [:view/project {:project-id project-id} (or (:project/name project) (tr [:applications/project]))]

      ;; only show business if there is only one of them
      (-> businesses count (= 1))
      (let [[business] businesses]
        [:view/business {:business-id (:db/id business)} (business-model/format-name business lang)]))))

(defn workspace-by-address [{:keys [lang match]}]
  (let [{:keys [workspace-id]
         :as   params}        (-> match :parameters :path)
        workspace             (<sub [::entities/entity {:workspace/id workspace-id}])
        tr                    (<sub [::ws-subs/tr-quiet])
        text                  (if (:workspace/primary-property workspace)
                                (:workspace/address workspace (tr [:workspace/missing-address]))
                                (or (-> workspace
                                        :workspace/category-group-config
                                        (config-model/localized-name lang))
                                    (tr [(:workspace/permit-type workspace)])
                                    workspace-id))]
    [:view/workspace params text]))

(defn form-by-name [{:keys [match]}]
  (let [{:keys [form-id]
         :as   params}   (-> match :parameters :path)
        form-schema      (when form-id
                           (-> (<sub [::entities/entity form-id])
                               :form/schema))]
    (when-let [form-name (:form.schema/name form-schema)]
      [:view/form params form-name])))

(defn inspection-by-name [{:keys [match]}]
  (let [params (-> match :parameters :path)
        tr     (<sub [::ws-subs/tr])]
    [:view/inspection-visit params (str (tr [:view/inspection-visit])
                                        " - "
                                        (<sub [:app.front.view.inspections.visit/inspection-name]))]))
